import { useStaticQuery, graphql } from 'gatsby';

const useGallery = () => {
  const data = useStaticQuery(graphql`
    query useGalleryQuery {
      allSanityGallery {
        nodes {
          title
          tag {
            title
          }
          image {
            alt
            asset {
              url
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
          _rawCaption
        }
      }
    }
  `);

  const gallery = data.allSanityGallery.nodes;

  return gallery;
};

export { useGallery };
